export default __webpack_public_path__ + "static/media/team-1@2x.a6361dcb.png";